<template>
  <div class="home">
    <div class="header">
      <div class="menu">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <img class="log" src="../content/img/hdlog.png" />
            </div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple-light home-menu">
              <div><router-link to="/"><span>首页</span></router-link></div>
              <div><router-link to="/notice"><span>会议通知</span></router-link></div>
              <div><router-link
                  :to="!isBlank(user) ? user.RoleId != '3' ? '/submit' : '/review' : '/submit'"><span>提交与评审系统</span></router-link>
              </div>
              <div v-if="isShowLogin" id="btn-login">
                <router-link to="/entrance"><span>注册</span></router-link> /
                <router-link to="/login"><span>登录</span></router-link>
              </div>
              <div v-else>
                <el-dropdown style="width: 220px;text-align:center;">
                  <span class="el-dropdown-link">
                    <router-link to="/" style="font-size: 16px;">{{
                      !isBlank(user) ? user.RoleId == '3' ? user.UserName : user.SchoolName : ''
                    }}</router-link>
                  </span>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <router-link to="/backIndex" style="text-decoration: none; color: black">
                        <el-dropdown-item v-if="user.RoleId == '1'">
                          <img src="../content/img/edit-2-line.png" width="20" height="20" alt="" />
                          <div class="item-text">后台管理</div>
                        </el-dropdown-item></router-link>
                      <router-link to="/info" style="text-decoration: none; color: black"><el-dropdown-item><img
                            src="../content/img/survey-line.png" width="20" height="20" alt="" />
                          <div class="item-text">个人中心 </div>
                        </el-dropdown-item></router-link>
                      <el-dropdown-item @click="close"><img src="../content/img/logout-circle-line.png" width="20"
                          height="20" alt="" style="color:black;" />
                        <div class="item-text">退出登录</div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </div>
          </el-col>
          <el-col :span="1">
            <div class="grid-content bg-purple"></div>
          </el-col>
        </el-row>
      </div>
      <div class="header-bg-img"></div>
    </div>
    <div class="content">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple content-left">
            <div class="left-content">
              <el-row>
                <el-col :span="9">
                  <div class="grid-content bg-purple text-notice">
                    <span>会议通知</span>
                  </div>
                </el-col>
                <el-col :span="3">
                </el-col>
                <el-col :span="11">
                  <div class="grid-content bg-purple-light text-more">
                    <span> <router-link to="/notice">更多</router-link></span>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="divider"></div>
            <div class="notice" v-for="(item, index) in noticeList.slice(0, 4)" :v-if="index < 4" v-bind:key="item.Id">
              <div class="notice-left">
                <span class="notice-img"><img src="../content/img/notification-line.png" /></span>
                <el-tooltip :content="item.Tilte" placement="bottom" effect="light">
                  <div class="txt-title cursor" @click="detail(item)">
                    {{
                      item.Tilte.length > 30
                        ? item.Tilte.substring(0, 30) + "···"
                        : item.Tilte
                    }}
                  </div>
                </el-tooltip>
              </div>
              <div class="notice-right">
                <div>{{ item.PublishTime }}</div>
              </div>
              <div class="divider-1"></div>
            </div>
          </div>
        </el-col>
        <el-col :span="1">
          <div class="grid-content bg-purple-light"></div>
        </el-col>
        <el-col :span="11">
          <div class="grid-content bg-purple content-right">
            <div class="right-title">提交与评审系统</div>
            <div class="right-content cursor" @click="redirect">
              <div class="right-Entrance">

                本科生创新创业论坛 <span class="icon"></span> <br />
                <br />
                <br />

                心理学教指委教改项目<span class="icon">
                  <!-- <img
                  class="right-icon"
                  src="../content/img/arrow-right-line.png"
              /> -->
                </span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { ref } from "vue";
import { _local } from "../utils/storage";
import router from "../router/index";
import { GetNoticeList } from "../http/notice";
import { ElMessage } from "element-plus";
import { LoginOut } from "../http/login";
import { isBlank } from '../utils/utils';
import Footer from '../views/base/BaseFooter.vue';
export default {
  name: "Home",
  components: {
    Footer
  },
  setup() {
    const close = () => {
      LoginOut().then((res) => {
        if (res.IsSuccess) {
          _local.remove("token");
          _local.remove("user");
          ElMessage({
            message: "退出成功",
            type: "success",
          });
          router.push("/login");
        } else {
          ElMessage.error(res.ErrorMessage);
        }
      });
    };
    const user = _local.get("user");
    let bgImg = {
      backgroundImage: require("../content/img/提交背景图.png"),
      backgroundRepeat: "no-repeat",
    };
    let noticeList = ref([]);
    const getNoticeList = async () => {
      await GetNoticeList({})
        .then((res) => {
          if (res.IsSuccess) {
            noticeList.value = res.Models;
            noticeList.value.forEach((m) => {
              m.PublishTime =
                new Date(m.PublishTime).getFullYear() +
                "-" +
                (new Date(m.PublishTime).getMonth() + 1) +
                "-" +
                new Date(m.PublishTime).getDate();
            });
          } else {
            ElMessage.error(res.ErrorMessage);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getNoticeList();
    let isShowLogin = ref(true);
    const isLogin = () => {
      if (_local.get("user")) {
        isShowLogin.value = false;
      } else {
        isShowLogin.value = true;
      }
    };
    let Entrance = require("../content/img/a32915fd0caeace3df03e6dc9510913.png");
    isLogin();
    let policeImg = require("../content/img/police.jpg");
    let img = require("../content/img/hdlog.png");
    let rightIcon = require("../content/img/arrow-right-line.png");
    let noticeIcon = require("../content/img/notification-line.png");
    const detail = (item) => {
      router.push({
        path: "/noticeDetail",
        query: {
          id: item.Id,
        },
      });
    };
    const redirect = () => {
      if (!isBlank(user)) {
        if (user.RoleId == '3') {
          router.push('/review');
        } else {
          router.push('/submit');
        }
      }
    }
    return {
      redirect,
      bgImg,
      noticeList,
      img,
      rightIcon,
      noticeIcon,
      policeImg,
      isShowLogin,
      Entrance,
      close,
      user,
      detail,
      isBlank
    };
  },
};
</script>
<style lang="scss" scoped>
.home {
  height: 100vh;
  width: 100%;
  position: relative;
  // max-height: 1080px;
  max-width: 1920px;
  margin: 0 auto;
}

.log {
  width: 265.9px;
  height: 48px;
  margin: 0 417.1px 0 0;
  padding: 0 34.2px 0 154.7px;
  background-color: var(--h-0-s-0-l-100);
  margin-top: 19px;
}

.menu {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 88px;
  max-height: 88px;
  -webkit-backdrop-filter: blur(32px);
  backdrop-filter: blur(32px);
  background-color: rgba(255, 255, 255, 0.2);
}

.item-text {
  width: 100px;
  height: 30px;
  float: right;
  line-height: 40px;
  margin-top: -6px;
  font-size: 14px;
  padding-left: 10px;
}

.item-text:hover {
  color: #409eff;
}

.home-menu {
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 720px;

  >div {
    // padding:0 5% 0 5%;
    // width: 150px;
    padding-right: 60px;
    color: white;

    a {
      color: white;
      text-decoration: none;
    }
  }
}

#btn-login {
  text-align: center;
  width: 152px;
  // margin: 9px 0 7px 58px;
  padding: 7px 0px;
  border: solid 1px white;

  >span {
    width: 28px;
    // height: 18px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: white;
  }
}

.header-bg-img {
  // min-height: 360px;
  height: 53vh;
  // height:468px;
  max-height: 500px;
  width: 100%;
  background-image: url("../content/img/提交背景图.png");
  background-size: cover;
  background-position: center;
  z-index: -1;
  max-width: 1920px;
}

.content {
  height: 40vh;
  width: 80%;
  margin: 0 auto;
  margin-top: 2vh;

}

.content-left {
  // min-width: 400px;
  min-width: 560px;
  max-width: 754px;
}

.left-content {
  height: 30px;
}

.notice-img {
  margin-right: 20px;

  // margin-top:5px;
  >img {
    width: 18px;
    height: 21.5px;
  }
}

.text-notice {
  text-align: left;

  >span {
    flex-grow: 0;
    font-family: MicrosoftYaHeiUI;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.64px;
    text-align: left;
    color: #4a4a4a;
    font-size: 20px;
  }
}

.text-more {
  text-align: right;

  >span {
    >a {
      line-height: 32px;
      text-decoration: none;
      color: black;
    }
  }
}

.divider {
  width: 100%;
  height: 1px;
  padding: 0.5px 0;
  background-color: #d7d8db;
  margin-top: 5px;
}

.notice {
  width: 100%;
  height: 45px;
  flex-grow: 0;
  padding-top: 5px;
  min-width: 420px;
  // padding: 12px 0 0;
  border-bottom: 1px solid #eee;

  .notice-left {
    // display: inline;
    float: left;
    // width: 70%;
    font-family: MicrosoftYaHei;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.85;
    letter-spacing: normal;
    // text-align: right;
    color: #716967;
    height: 48px;

    .txt-title {
      // float: left;
      //  display: inline;
      line-height: 24px;
      height: 24px;
      margin: -30px 0 0 28px;
    }
  }

  .notice-right {
    // display: inline;
    // width: 30%;
    float: right;
    width: 80px;
    min-width: 80px;
    // height: 24px;
    font-family: MicrosoftYaHei;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.85;
    letter-spacing: normal;
    text-align: right;
    color: #716967;
  }
}

.content-right {
  width: 100%;
  height: 400px;
  margin-left: 120px;

  .right-title {
    height: 30px;
    flex-grow: 0;
    font-family: MicrosoftYaHeiUI;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.64px;
    text-align: left;
    color: #4a4a4a;
    font-size: 20px;
    margin-bottom: 5px;
  }

  .right-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 20vh;
    max-height: 220px;
    min-width: 240px;
    max-width: 300px;
    background-color: #f9f9f9;

    .right-icon {
      width: 16px;
      height: 15.6px;
      flex-grow: 0;
      margin: 0 0 0 5px;
    }

    .right-Entrance {
      >a {
        text-decoration: none;
        color: #666;
      }
    }

    >span {
      font-family: MicrosoftYaHei;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      // line-height: 1.6;
      letter-spacing: normal;
      text-align: left;
      color: #4a4a4a;
    }

    >a {
      font-family: MicrosoftYaHei;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      text-decoration: none;
      z-index: 100;
    }
  }
}

.cursor {
  cursor: pointer;
}
</style>